import Loadable from '../../../components/loadable';

const MembershipPage = Loadable({
  loader: () => import('../../../pages/contacts/memberships/membership'),
  type: 'block',
});

angular.module('gym').value('MembershipPage', MembershipPage);

const MembershipPaymentsTabFiltersModal = Loadable({
  loader: () =>
    import('../../../pages/contacts/memberships/membership/membership_payments_tab_filters_modal'),
  type: 'modal',
});

angular.module('gym').value('MembershipPaymentsTabFiltersModal', MembershipPaymentsTabFiltersModal);

const MembershipSequencesTabFiltersModal = Loadable({
  loader: () =>
    import('../../../pages/contacts/memberships/membership/membership_sequences_tab_filters_modal'),
  type: 'modal',
});

angular
  .module('gym')
  .value('MembershipSequencesTabFiltersModal', MembershipSequencesTabFiltersModal);
